import { projectDocumentQueries } from '@ztechapps/project.common'
import { useActionMutation, useHistory } from '@ztechapps/common.hook'
import type { RouteDef, Project } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import type { ProjectAddFormValues } from './Context'

export const useProjectAdd = () => {
  const [onAdd, { error, loading }] = useActionMutation<Project, Project>({
    query: projectDocumentQueries.createConfig.query,
  })
  const history = useHistory()
  const projectItemRoute = useInject<RouteDef>(WebuiIocKey.routes.projectItem)

  const onSubmit = async ({ name, summary }: ProjectAddFormValues): Promise<void> => {
    const input = {
      name,
      summary,
    } as Project
    const project = await onAdd(input)

    // if then navigate to necessary field is no error then navigate to
    const route = projectItemRoute.altPath({
      _id: project?._id,
    })

    history.push(route)
  }

  return { onSubmit, error, loading }
}
